export default "<h1>Theme 主题</h1>\n<p>我们最推崇的就是主题模式了, 它可以很轻松的切换内置的不同样式, 我们目前支持 <code>light</code> 和 <code>dark</code> 两种风格可供选择.</p>\n"